import { render, staticRenderFns } from "./detailPage.html?vue&type=template&id=2533cf5a&scoped=true&"
import script from "./detailPage.js?vue&type=script&lang=js&"
export * from "./detailPage.js?vue&type=script&lang=js&"
import style0 from "./detailPage.styl?vue&type=style&index=0&id=2533cf5a&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533cf5a",
  null
  
)

export default component.exports